import './index.sass';

const initTooltip = () => {
  $("[data-tooltip]").each((index, item) => {
    const $this = $(item);
    const $data_tooltip = $this.attr("data-tooltip");
    const $tooltip = $this.find("#tooltip");
    if($(window).outerWidth() > 1080) {
      $(item).on('mousemove',function () {
        $tooltip.text($data_tooltip)
          .css({
            "top": '-40px',
            "left": '0'
          })
          .show();
      }).on('mouseout',function () {
        $tooltip.hide()
          .text("")
          .css({
            "top": 0,
            "left": 0
          });
      });
    } else {
      $(item).off('mousemove');
      $(item).off('mouseout');
    }
  })
}

export {
  initTooltip
}
